import { render } from "./caricaTicketModal.vue?vue&type=template&id=2a1d1c24&ts=true"
import script from "./caricaTicketModal.vue?vue&type=script&lang=ts"
export * from "./caricaTicketModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__